import { forIn, isArray, random, forEach } from "lodash";
import { firestore, auth } from "../_firebase";
import Collection from "../_collections";
import { updateObject } from "../_utils";
import profileConstants from "../_constants/profileConstants";
import matchesConstants from "../_constants/matchesConstants";

const getRecentlyViewed = () => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.PROFILE_VIEWS)
      .where("viewerId", "==", userId)
      .orderBy("viewedAt", "desc")
      .limit(6)
      .get()
      .then(results => {
        let searchResults = [];

        results.forEach(result => {
          let resultData = result.data();

          searchResults.push(resultData);
        });
        let lastResult = null;
        if (results.size !== 0) {
          lastResult = results.docs[results.docs.length - 1].id;
        }
        resolve({ results: searchResults, lastResult });
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};
const getMemberProfile = profileId => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.USERS)
      .doc(profileId)
      .get()
      .then(user => {
        resolve(updateObject(user.data(), { id: user.id }));
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};
const getLiked = () => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.PROFILE_LIKES)
      .where("userId", "==", userId)
      .orderBy("createdAt", "desc")
      .limit(6)
      .get()
      .then(results => {
        let searchResults = [];

        results.forEach(result => {
          let resultData = result.data();

          searchResults.push(resultData);
        });
        let lastResult = null;
        if (results.size !== 0) {
          lastResult = results.docs[results.docs.length - 1].id;
        }
        resolve({ results: searchResults, lastResult });
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};
const getSaved = () => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.SAVES)
      .where("userId", "==", userId)
      .orderBy("createdAt", "desc")
      .limit(6)
      .get()
      .then(results => {
        let searchResults = [];

        results.forEach(result => {
          let resultData = result.data();

          searchResults.push(resultData);
        });
        let lastResult = null;
        if (results.size !== 0) {
          lastResult = results.docs[results.docs.length - 1].id;
        }
        resolve({ results: searchResults, lastResult });
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};
const getShortlisted = () => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.SHORTLISTS)
      .where("userId", "==", userId)
      .orderBy("createdAt", "desc")
      .limit(6)
      .get()
      .then(results => {
        let searchResults = [];

        results.forEach(result => {
          let resultData = result.data();

          searchResults.push(resultData);
        });
        let lastResult = null;
        if (results.size !== 0) {
          lastResult = results.docs[results.docs.length - 1].id;
        }
        resolve({ results: searchResults, lastResult });
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};
const getExpressedInterest = () => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.INTERESTS)
      .where("userId", "==", userId)
      .orderBy("createdAt", "desc")
      .limit(6)
      .get()
      .then(results => {
        let searchResults = [];

        results.forEach(result => {
          let resultData = result.data();

          searchResults.push(resultData);
        });
        let lastResult = null;
        if (results.size !== 0) {
          lastResult = results.docs[results.docs.length - 1].id;
        }
        resolve({ results: searchResults, lastResult });
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};
const getFavorite = () => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.FAVORITES)
      .where("userId", "==", userId)
      .orderBy("createdAt", "desc")
      .limit(6)
      .get()
      .then(results => {
        let searchResults = [];

        results.forEach(result => {
          let resultData = result.data();

          searchResults.push(resultData);
        });
        let lastResult = null;
        if (results.size !== 0) {
          lastResult = results.docs[results.docs.length - 1].id;
        }
        resolve({ results: searchResults, lastResult });
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};
const getProfileVisitors = () => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.PROFILE_VIEWS)
      .where("profileId", "==", userId)
      .orderBy("viewedAt", "desc")
      .limit(6)
      .get()
      .then(results => {
        let searchResults = [];

        results.forEach(result => {
          let resultData = result.data();

          searchResults.push(resultData);
        });
        let lastResult = null;
        if (results.size !== 0) {
          lastResult = results.docs[results.docs.length - 1].id;
        }
        resolve({ results: searchResults, lastResult });
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};
const getPendingInvitations = () => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.CONNECTS)
      .where("userId", "==", userId)
      .where("status", "==", profileConstants.CONNECT_PENDING_STATUS)
      .orderBy("createdAt", "desc")
      .limit(6)
      .get()
      .then(results => {
        let searchResults = [];

        results.forEach(result => {
          let resultData = result.data();

          searchResults.push(resultData);
        });
        let lastResult = null;
        if (results.size !== 0) {
          lastResult = results.docs[results.docs.length - 1].id;
        }
        resolve({ results: searchResults, lastResult });
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};
const getAcceptInvitations = () => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.CONNECTS)
      .where("profileId", "==", userId)
      .where("status", "==", profileConstants.CONNECT_PENDING_STATUS)
      .orderBy("createdAt", "desc")
      .limit(6)
      .get()
      .then(results => {
        let searchResults = [];

        results.forEach(result => {
          let resultData = result.data();

          searchResults.push(resultData);
        });
        let lastResult = null;
        if (results.size !== 0) {
          lastResult = results.docs[results.docs.length - 1].id;
        }
        resolve({ results: searchResults, lastResult });
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};
const getPeopleWhoLikedMe = () => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.PROFILE_LIKES)
      .where("profileId", "==", userId)
      .orderBy("createdAt", "desc")
      .limit(6)
      .get()
      .then(results => {
        let searchResults = [];

        results.forEach(result => {
          let resultData = result.data();

          searchResults.push(resultData);
        });
        let lastResult = null;
        if (results.size !== 0) {
          lastResult = results.docs[results.docs.length - 1].id;
        }
        resolve({ results: searchResults, lastResult });
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};
const getPeopleExpressedInterestInMe = () => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.INTERESTS)
      .where("profileId", "==", userId)
      .orderBy("createdAt", "desc")
      .limit(6)
      .get()
      .then(results => {
        let searchResults = [];

        results.forEach(result => {
          let resultData = result.data();

          searchResults.push(resultData);
        });
        let lastResult = null;
        if (results.size !== 0) {
          lastResult = results.docs[results.docs.length - 1].id;
        }
        resolve({ results: searchResults, lastResult });
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};
const getConnectedMembers = () => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.CONNECTS)
      .where("userId", "==", userId)
      .where("status", "==", profileConstants.CONNECT_APPROVED_STATUS)
      .orderBy("approvedAt", "desc")
      .limit(6)
      .get()
      .then(results => {
        let searchResults = [];

        results.forEach(result => {
          let resultData = result.data();

          searchResults.push(resultData);
        });
        let lastResult = null;
        if (results.size !== 0) {
          lastResult = results.docs[results.docs.length - 1].id;
        }
        resolve({ results: searchResults, lastResult });
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};

const loadMoreResults = (lastResult, type) => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;
    let query, getQuery;
    let stateRef;
    if (!lastResult) {
      reject("Please try again later");
    }

    if (type === matchesConstants.GET_LIKED_MEMBERS) {
      query = firestore
        .collection(Collection.PROFILE_LIKES)
        .where("userId", "==", userId)
        .orderBy("createdAt", "desc")
        .limit(6);
      stateRef = "liked";
      getQuery = firestore.collection(Collection.PROFILE_LIKES);
    }

    if (type === matchesConstants.GET_EXPRESSED_INTEREST_MEMBERS) {
      query = firestore
        .collection(Collection.INTERESTS)
        .where("userId", "==", userId)
        .orderBy("createdAt", "desc")
        .limit(6);
      stateRef = "expressedInterest";
      getQuery = firestore.collection(Collection.INTERESTS);
    }

    if (type === matchesConstants.GET_FAVORITE_MEMBERS) {
      query = firestore
        .collection(Collection.FAVORITES)
        .where("userId", "==", userId)
        .orderBy("createdAt", "desc")
        .limit(6);
      stateRef = "favorite";
      getQuery = firestore.collection(Collection.FAVORITES);
    }

    if (type === matchesConstants.GET_SAVED_MEMBERS) {
      query = firestore
        .collection(Collection.SAVES)
        .where("userId", "==", userId)
        .orderBy("createdAt", "desc")
        .limit(6);
      stateRef = "saved";
      getQuery = firestore.collection(Collection.SAVES);
    }

    if (type === matchesConstants.GET_SHORTLISTED_MEMBERS) {
      query = firestore
        .collection(Collection.SHORTLISTS)
        .where("userId", "==", userId)
        .orderBy("createdAt", "desc")
        .limit(6);
      stateRef = "shortlisted";
      getQuery = firestore.collection(Collection.SHORTLISTS);
    }

    if (type === matchesConstants.RECENTLY_VIEWED_MEMBERS) {
      query = firestore
        .collection(Collection.PROFILE_VIEWS)
        .where("viewerId", "==", userId)
        .orderBy("viewedAt", "desc")
        .limit(6);
      stateRef = "recentlyViewed";
      getQuery = firestore.collection(Collection.PROFILE_VIEWS);
    }

    if (type === matchesConstants.GET_PROFILE_VISITORS) {
      query = firestore
        .collection(Collection.PROFILE_VIEWS)
        .where("profileId", "==", userId)
        .orderBy("viewedAt", "desc")
        .limit(6);
      stateRef = "visitors";
      getQuery = firestore.collection(Collection.PROFILE_VIEWS);
    }

    if (type === matchesConstants.GET_PENDING_INVITATIONS) {
      query = firestore
        .collection(Collection.CONNECTS)
        .where("userId", "==", userId)
        .where("status", "==", profileConstants.CONNECT_PENDING_STATUS)
        .orderBy("createdAt", "desc")
        .limit(6);
      stateRef = "pendingInvitations";
      getQuery = firestore.collection(Collection.CONNECTS);
    }

    if (type === matchesConstants.GET_ACCEPT_INVITATIONS) {
      query = firestore
        .collection(Collection.CONNECTS)
        .where("profileId", "==", userId)
        .where("status", "==", profileConstants.CONNECT_PENDING_STATUS)
        .orderBy("createdAt", "desc")
        .limit(6);
      stateRef = "acceptInvitations";
      getQuery = firestore.collection(Collection.CONNECTS);
    }

    if (type === matchesConstants.GET_PEOPLE_WHO_LIKED_ME) {
      query = firestore
        .collection(Collection.PROFILE_LIKES)
        .where("profileId", "==", userId)
        .orderBy("createdAt", "desc")
        .limit(6);
      stateRef = "likedMe";
      getQuery = firestore.collection(Collection.PROFILE_LIKES);
    }

    if (type === matchesConstants.GET_PEOPLE_EXPRESSED_INTEREST_IN_ME) {
      query = firestore
        .collection(Collection.INTERESTS)
        .where("profileId", "==", userId)
        .orderBy("createdAt", "desc")
        .limit(6);
      stateRef = "interestedInMe";
      getQuery = firestore.collection(Collection.INTERESTS);
    }

    if (type === matchesConstants.GET_CONNECTED_MEMBERS) {
      query = firestore
        .collection(Collection.CONNECTS)
        .where("userId", "==", userId)
        .where("status", "==", profileConstants.CONNECT_APPROVED_STATUS)
        .orderBy("approvedAt", "desc")
        .limit(6);
      stateRef = "connected";
      getQuery = firestore.collection(Collection.CONNECTS);
    }
    getQuery
      .doc(lastResult)
      .get()
      .then(doc => {
        if (doc.exists) {
          query
            .startAfter(doc)
            .get()
            .then(results => {
              let searchResults = [];

              results.forEach(result => {
                searchResults.push({ ...result.data(), ...{ id: result.id } });
              });
              let hasMoreResults = results.size === 0 ? false : true;
              let lastResult = null;
              if (results.size !== 0) {
                lastResult = results.docs[results.docs.length - 1].id;
              }

              resolve({ results: searchResults, lastResult, stateRef });
            })
            .catch(err => {
              console.log(err);
              reject("Please try again later");
            });
        } else {
          console.log(doc);
          reject("Please try again later");
        }
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};
const markProfileVisitorsRead = () => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.USERS)
      .doc(userId)
      .update({
        profileVisitors: 0
      })
      .then(doc => {
        resolve();
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};

const markInvitationsReceivedRead = () => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.USERS)
      .doc(userId)
      .update({
        invitationsReceived: 0
      })
      .then(doc => {
        resolve();
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};

const markConnectedMembersRead = () => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.USERS)
      .doc(userId)
      .update({
        connectedNotification: 0
      })
      .then(doc => {
        resolve();
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};

const markInterestsRead = () => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.USERS)
      .doc(userId)
      .update({
        interestsNotification: 0
      })
      .then(doc => {
        resolve();
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};
const markLikesRead = () => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.USERS)
      .doc(userId)
      .update({
        likesNotification: 0
      })
      .then(doc => {
        resolve();
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};

const searchService = {
  getRecentlyViewed,
  getMemberProfile,
  getLiked,
  getSaved,
  getShortlisted,
  getExpressedInterest,
  getFavorite,
  getProfileVisitors,
  getPendingInvitations,
  getAcceptInvitations,
  getPeopleWhoLikedMe,
  getPeopleExpressedInterestInMe,
  getConnectedMembers,
  loadMoreResults,
  markProfileVisitorsRead,
  markInvitationsReceivedRead,
  markConnectedMembersRead,
  markInterestsRead,
  markLikesRead
};
export default searchService;



// WEBPACK FOOTER //
// ./src/_services/matchesService.js